<template>
  <div :class="['nav-wrap', isFixed ? 'fixed' : '']">
    <div class="nav-con">
      <a
        :href="item.href"
        :class="['nav', item.active ? 'active' : '']"
        v-for="(item, index) in dataList"
        :key="index"
        @click="changeNav(index)"
      >
        {{ item.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: Array,
  },
  data() {
    return {
      // 用于控制消失动画
      disappear: false,
      isFixed: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    changeNav(index) {
      this.dataList.forEach((e) => {
        e.active = false
      })
      this.dataList[index].active = true
    },
    // 滚动监听
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.isFixed = scrollTop >= 560
      if (scrollTop < 1600) {
        this.dataList.forEach((e) => {
          e.active = false
        })
        this.dataList[0].active = true
      }
      if (scrollTop >= 1800 && scrollTop <= 2400) {
        this.dataList.forEach((e) => {
          e.active = false
        })
        this.dataList[1].active = true
      }
      if (scrollTop >= 2400 && scrollTop <= 3300) {
        this.dataList.forEach((e) => {
          e.active = false
        })
        this.dataList[2].active = true
      }
      if (scrollTop >= 3300 && scrollTop <= 4100) {
        this.dataList.forEach((e) => {
          e.active = false
        })
        this.dataList[3].active = true
      }
      if (scrollTop > 4100) {
        this.dataList.forEach((e) => {
          e.active = false
        })
        this.dataList[4].active = true
      }
    },
  },
  computed: {},
}
</script>

<style lang="less" scoped>
.nav-wrap {
  background: #ffffff;
  box-shadow: 0px 5px 6px 0px rgba(213,213,213,0.5);
  max-width: 100%;
  top: 60px;
  transition: all 0.4s ease-in-out;
  .nav-con {
    height: 60px;
    max-width: 1320px;
    margin: 0 auto;
    display: flex;
    align-content: center;
    justify-content: space-between;
    background: #ffffff;
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 60px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #202640;
      line-height: 26px;
      background: #ffffff;
      // text-decoration:;
    }
    .active {
      position: relative;
      &::after {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -48px;
        width: 96px;
        height: 4px;
        background-color: #e61717;
      }
    }
  }
}
.fixed {
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 3;
}
</style>
